<template>
  <div class="mx-auto">
    <v-card flat class="pa-2">
      <v-card-text>
        <v-container>
          <div class="font-weight-medium black--text mb-1" style="font-size: 20px">
            Lengkapi Narasumber Kelas
          </div>
          <p class="body-2">Silahkan pilih Narasumber utama dan Narasumber bantu</p>
          <v-list>
            <div v-for="(sch, id) in schema" :key="id">
              <v-divider v-if="id > 0" />
              <v-list-item :key="id">
                <v-list-item-content>
                  <v-row>
                    <v-col cols="12" lg="2" class="my-auto">
                      <div class="text-body-1 font-weight-medium">
                        {{ sch.label }} <span v-if="sch.optional" class="body-2 grey--text">(opsional)</span>
                      </div>
                    </v-col>
                    <v-col cols="12" lg="4" class="my-auto">
                      <v-autocomplete
                        v-model="form[sch.key]"
                        :items="kandidats"
                        placeholder="-- Silakan Pilih Narasumber --"
                        clearable
                        hide-no-data
                        single-line
                        item-text="nama"
                        item-value="akun_id"
                        dense
                        outlined
                        hide-details
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-list>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  props: {
    initValue: {
      type: [Object, Array],
      default: () => null,
    },
    kandidats: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {},
      schema: [
        { label: 'Narasumber Utama', key: 2 },
        { label: 'Narasumber Bantu', key: 3, optional: true },
      ],
    };
  },
  computed: {},
  methods: {
    reset() {
      this.$set(this, 'form', {});

      for (const sch of this.schema) {
        this.$set(this.form, sch.key, '');
      }
    },

    initForm(value) {
      if (!value) return;

      for (const item of value) {
        const key = item.k_pelatihan_peserta_psp;
        this.$set(this.form, key, item.akun_id);
      }
    },

    getValue() {
      let result = [];

      for (const key in this.form) {
        const akunId = this.form[key] || '';

        if (akunId) {
          result.push({ k_pelatihan_peserta_psp: key, akun_id: akunId });
        }
      }

      return result;
    },
  },

  watch: {
    initValue: 'initForm',
  },
};
</script>
